import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WebDatatable from 'app/shared/datatable/web/datatable';
import MobileDatatable from 'app/shared/datatable/mobile/datatable';
import GmModal from 'app/shared/modal/modal';

import { setPageTitle } from 'store/actions/header';
import { useDemoService } from 'hooks/api/users/demo';
import { loadDemosToStore } from 'store/actions/demo';
import { DemoDetail } from '../view';

export const DemoListPage = () => {
  const navigateTo = useNavigate();
  const dispatch = useDispatch();
  const { fetchDemos, searchDemos } = useDemoService();

  const { is_mobile_view } = useSelector((state) => state.metadata);
  const demos_in_store = useSelector((state) => state.demos);

  const [demos, setDemos] = useState([]);
  const [is_search_mode, setSearchMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [total_demos, setTotalDemos] = useState(0);
  const [selected_demo, setSelectedDemo] = useState(null);

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Demos', path: '.' }]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDemos(Object.values(demos_in_store).filter((demo) => demo.type === 'demo'));
  }, [demos_in_store]);

  const config = {
    actions: {
      single: () => []
    },
    allow_bulk_action: true,
    css: {},
    fields: [
      {
        title: 'Name',
        key: 'meta',
        isTitle: true,
        searchable: true,
        formatter: (value) =>
          value.fullname || value.firstname
            ? `${value.firstname} ${value.lastname}`
            : `${value.first_name} ${value.last_name}`
      },
      {
        title: 'Email',
        key: 'meta',
        isTagline: true,
        searchable: true,
        formatter: (value) => value.email || 'N/A'
      },
      {
        title: 'Company',
        key: 'meta',
        searchable: true,
        formatter: (value) => value.company_name || value.company,
        isBadge: true
      },
      {
        title: 'Phone Number',
        key: 'meta',
        searchable: true,
        formatter: (value) => value.phone_number || value.phone,
        isBadge: true
      },
      {
        title: 'Subscribers',
        key: 'meta',
        formatter: (value) => value.subscribers || value.list_size,
        isMetadata: true
      }
    ],
    is_search_mode,
    items: demos.sort((a, b) => b.id - a.id),
    search_key: 'name',
    search_text: ''
  };

  const handleDatatableAction = (payload) => {
    const { name, type, data } = payload;

    if (type === 'single') {
      switch (name) {
        default:
          navigateTo(`/demos/${data.id}`);
      }
    }
  };

  const handleItemClick = (payload) => {
    setSelectedDemo(payload);
  };

  const handleDataRequest = async (page, population = 10) => {
    try {
      setLoading(true);
      const { demos, size } = await fetchDemos({
        query_string: `type=demo&page=${page}&population=${population}&sort_by=-created_on`
      });

      dispatch(loadDemosToStore(demos.map((demo) => ({ ...demo, meta: demo.metadata }))));
      setTotalDemos(size);
    } catch (e) {
      dispatch(loadDemosToStore([]));
    } finally {
      setLoading(false);
    }
  };

  const handleSearchRequest = async (keys, keyword, page, population = 10) => {
    if (!keys) return;
    try {
      setLoading(true);
      const { demos, size } = await searchDemos(keys, keyword, {
        query_string: `type=demo&page=${page}&population=${population}&sort_by=-created_on`
      });

      setTotalDemos(size);
      dispatch(loadDemosToStore(demos.map((demo) => ({ ...demo, meta: demo.metadata }))));
    } catch (e) {
      dispatch(loadDemosToStore([]));
    } finally {
      setLoading(false);
    }
  };

  const table_actions = <></>;

  return (
    <div>
      {is_mobile_view ? (
        <MobileDatatable
          config={config}
          action={handleDatatableAction}
          onClick={handleItemClick}
          onListModeChange={setSearchMode}
          onDataRequest={handleDataRequest}
          onSearchRequest={handleSearchRequest}
        />
      ) : (
        <WebDatatable
          config={{
            ...config,
            total_count: total_demos
          }}
          action={handleDatatableAction}
          onClick={handleItemClick}
          checkbox
          loading_data={loading}
          table_actions={table_actions}
          onDataRequest={handleDataRequest}
          onSearchRequest={handleSearchRequest}
        />
      )}

      <GmModal
        title={
          selected_demo
            ? `${selected_demo.meta?.firstname || ''} ${
                selected_demo.meta?.lastname || ''
              }`.trim() || 'Demo'
            : 'Demo'
        }
        show_title
        show_modal={!!selected_demo}
        onClose={() => setSelectedDemo(null)}
      >
        <DemoDetail demo={selected_demo} />
      </GmModal>
    </div>
  );
};
